<template>
  <div>

  <div class="row vpad"> 
    <div class="col s12 yo-align-center"><img src="http://centrocongressibergamo.yota.it/20190928/images/head.png" style="height:240px;"/></div>
  </div>

<div class="title_h1 yo-color-primary" style="margin-top:30px;">ISCRIZIONE AVVENUTA CON SUCCESSO</div>
<br />
Le confermiamo  l’avvenuta iscrizione al convegno in oggetto.
<br />
A breve riceverà una mail con la conferma d’iscrizione che le chiediamo di portare in sede di evento.
<br /><br />
Cordiali saluti
<br /><br />
La Segreteria Organizzativa
<br /><br />
 
<br /><br />
CENTRO CONGRESSI GIOVANNI XXIII
<br /><br />
<a href="mailto:eventi@centrocongressibergamo.com">eventi@centrocongressibergamo.com</a>
<br /><br />
tel. + 035 236435 





    <div class="row pad" style="margin-top:20px;">
        
      <div class="col s12 m6 offset-m3">
          <el-button type="primary" @click="onNew" style="width:100%;background-color:#002f6d;border:none;margin:10px 0;">Nuova registrazione</el-button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  methods: {
    onNew() {
        this.$teras.event.emit('logout')
    }
  }
}
</script>


<style scoped>
  .home{
    background:#fff;
    min-height:600px;
    padding:20px;
  }
</style>
